var lyap = {
    init: function () {
        this.Global.init();
        this.Header.init();
        this.Pages.init();
        this.Ajax();
        console.log('main');
    },

    Global: {
        init: function () {
            this.MagnifyPopup.init();
            this.Slider.init();
        },

        MagnifyPopup: {
            init: function () {
                this.close();
                this.onMagnifyClick();
                this.onWindowResize();
            },

            close: function () {
                $('body').on('click', '.popup', function (e) {
                    ($(e.target).hasClass('btn--close') || $(e.target).hasClass('popup__wrapper') || $(e.target).hasClass('popup')) && $('.popup').remove();
                });
            },

            generate: function (src, alt) {
                $('body').append(
                    '<div class="popup flexbox center middle">' +
                        '<div class="container">' +
                            '<div class="popup__wrapper flexbox center middle">' +
                                '<div class="popup__window">' +
                                    '<button class="btn--close flexbox center middle" type="button">' +
                                        '<span class="cross">' +
                                            '<span></span>' +
                                            '<span></span>' +
                                        '</span>' +
                                    '</button>' +
                                    '<img src="' + src + '" alt="' + alt + '">' +
                                '</div>' +
                            '</div>' +
                        '</div>' +
                    '</div>'
                );
            },

            onMagnifyClick: function () {
                $('body').on('click', '.magnify', function () {
                    if ($(window).width() > 991) {
                        var str, src, alt;

                        if ($(this).is('img')) {
                            src = $(this).attr('src');
                            alt = $(this).attr('alt');
                        } else {
                            str = $(this).attr('style');
                            src = str.substring(str.indexOf("'") + 1, str.lastIndexOf("'"));
                            alt = '';
                        }

                        lyap.Global.MagnifyPopup.generate(src, alt);
                    }
                });
            },

            onWindowResize: function () {
                $(window).on('resize', function () {
                    ($(window).width() < 992 && $('.popup').length > 0) && $('.popup').remove();
                });
            }
        },

        Slider: {
            init: function () {
                this.Button.init();
                this.onLoad();
                this.onNavOptionClick();
                this.onWindowResize();
            },

            adjustSlideBodyWidthToHeader: function (slider) {
                var slides = slider !== undefined ? slider.find('.slide') : $('.slide');

                slides.each(slide => {
                    var imgWidth = $(slides[slide]).find('.slide__header img').css('width');
                    $(slides[slide]).find('.slide__body').css('width', imgWidth);
                });
            },

            Button: {
                init: function () {
                    this.onClick();
                },

                generate: function (slider) {
                    slider.append(
                        '<button class="btn--next" type="button">' +
                            '<span class="angle--double">' +
                                '<span class="angle angle--down black">' +
                                    '<span></span>' +
                                    '<span></span>' +
                                '</span>' +
                                '<span class="angle angle--down black">' +
                                    '<span></span>' +
                                    '<span></span>' +
                                '</span>' +
                            '</span>' +
                        '</button>'
                    );
                },

                onClick: function () {
                    $('.panel--slider').on('click', '.btn--next', function () {
                        var wrapper = $(this).siblings('.slides-wrapper'),
                            tgt = wrapper.find('.slide:first-of-type');

                        wrapper.append(tgt);
                    });
                },

                remove: function (slider) {
                    slider.find('.btn--next').remove();
                },

                toggle: function (slider) {
                    slider.find('.slides-wrapper').width() > slider.width()
                        ? (slider.find('.btn--next').length < 1 && lyap.Global.Slider.Button.generate(slider))
                        : lyap.Global.Slider.Button.remove(slider);
                }
            },

            generateSlides: function (lang, sliderName, activeYear, slidesWrapper) {
                $('#' + sliderName + ' .slider__intro').length > 0 && $('#' + sliderName + ' .slider__intro').remove();

                $.each(data[lang][sliderName][activeYear], function (idx, el) {
                    if (el.type === 'intro') {
                        $('<div class="slider__intro"></div>').insertAfter('.slider__title');
                        $('#' + sliderName + ' .slider__intro').html(el.text);
                    } else {
                        if (el.type === 'student') {
                            content = '<h3>' + el.title + '</h3>' +
                                '<p><strong>' + (lang == "EN" ? 'From' : 'De ') + ':</strong><br />' + el.origin + '</p>' +
                                '<p><strong>' + (lang == "EN" ? 'Studying for' : 'Etudiant(e) en ') + ':</strong><br />' + el.studies + '</p>'
                        } else if (el.type === 'article') {
                            content = '<h3>' + el.title + '</h3>' +
                                '<p>' + el.text + '</p>'
                        } else {
                            content = '<p class="plain-text">' + el.text + '</p>'
                        }

                        slidesWrapper.append(
                            '<div class="slide">' +
                                '<div class="slide__header">' +
                                    '<img class="magnify" src="/images/pages/programs/' + el.img + '.jpg" alt="people holding certificate" />' +
                                '</div>' +
                                '<div class="slide__body">' + content + '</div>' +
                            '</div>'
                        );
                    }
                });
            },

            onLoad: function () {
                var sliders = $('.panel--slider'),
                    lang = $('.header__lang a.active').attr('data-language')
                               ? $('.header__lang a.active').attr('data-language').split('-')[0].toUpperCase()
                               : $('.header__lang a.active').text().toUpperCase();

                sliders.each(slider => {
                    var el = $(sliders[slider]),
                        sliderName = el.attr('id'),
                        activeYear = el.find('.slider__nav li.active .link-text').text(),
                        slidesWrapper = el.find('.slides-wrapper');

                    el.find('.slider__title .year').text(activeYear);
                    lyap.Global.Slider.generateSlides(lang, sliderName, activeYear, slidesWrapper);
                    setTimeout(function () {
                        lyap.Global.Slider.adjustSlideBodyWidthToHeader(sliders);
                        $(window).width() > 991 && lyap.Global.Slider.Button.toggle(el.find('.slider'));
                    }, 750);
                    setTimeout(function () {
                        el.find('.slider').addClass('visible');
                    }, 800);
                });
            },

            onNavOptionClick: function () {
                $('.slider__nav li').on('click', function () {
                    var lang = $('.header__lang a.active').attr('data-language')
                                   ? $('.header__lang a.active').attr('data-language').split('-')[0].toUpperCase()
                                   : $('.header__lang a.active').text().toUpperCase();

                    if (!$(this).hasClass('active')) {
                        var activeYear = $('.link-text', this).text(),
                            panel = $(this).closest('.panel--slider'),
                            slider = panel.find('.slider');
                        sliderName = panel.attr('id'),
                            slidesWrapper = slider.find('.slides-wrapper');

                        $(this).siblings('li').removeClass('active');
                        $(this).addClass('active');
                        slider.removeClass('visible');
                        slidesWrapper.html('');
                        panel.find('.slider__title .year').text(activeYear);
                        lyap.Global.Slider.generateSlides(lang, sliderName, activeYear, slidesWrapper);
                        setTimeout(function () {
                            lyap.Global.Slider.adjustSlideBodyWidthToHeader(slider);
                            $(window).width() > 991 && lyap.Global.Slider.Button.toggle(slider);
                        }, 750);
                        setTimeout(function () {
                            slider.addClass('visible');
                        }, 800);
                    }
                });
            },

            onWindowResize: function () {
                $(window).on('resize', function () {
                    if ($('.panel--slider').length > 0) {
                        var sliders = $('.slider');

                        lyap.Global.Slider.adjustSlideBodyWidthToHeader();
                        if ($(window).width() > 991) {
                            sliders.each(slider => {
                                lyap.Global.Slider.Button.toggle($(sliders[slider]));
                            });
                        } else {
                            sliders.each(slider => {
                                $(sliders[slider]).find('.btn--next').length > 0
                                    && $(sliders[slider]).find('.btn--next').remove();
                            });
                        }
                    }
                });
            }
        }
    },

    Header: {
        init: function () {
            this.handleBurgerMenuClick();
            this.handleNavActivePage();
        },

        handleBurgerMenuClick: function () {
            $('body').on('click', '#burgerMenu', function () {
                if ($(this).hasClass('active')) {
                    $(this).removeClass('active');
                    $('#header .menus').removeClass('active');
                } else {
                    $(this).addClass('active');
                    $('#header .menus').addClass('active');
                }
            });
        },

        handleNavActivePage: function () {
            var urlStr = $(location).attr('href').split('/'),
                page = urlStr[urlStr.length - 1].split('#')[0].toLowerCase(),
                menu = $('#headerNav a');

            menu.each(idx => {
                $(menu[idx]).attr('href').toLowerCase() == '/' + page
                    ? $(menu[idx]).addClass('active')
                    : $(menu[idx]).removeClass('active');
            });
        }
    },

    Pages: {
        init: function () {
            this.Home.init();
        },

        Home: {
            init: function () {
                var txt = [
                    'These students come from all over the world:<br /><span>NETHERLANDS &#8226; GERMANY &#8226; ITALY &#8226; GREECE &#8226; BULGARIA &#8226; ALBANIA &#8226; LITHUANIA &#8226; ARMENIA &#8226; IRAN &#8226; SYRIA &#8226; BANGLADESH &#8226; EGYPT &#8226; SENEGAL &#8226; GHANA &#8226; ZIMBABWE &#8226; CHINA &#8226; MEXICO</span>',
                    'Ces &eacute;tudiants viennent du monde entier :<br /><span>PAYS-BAS &#8226; ALLEMAGNE &#8226; ITALIE &#8226; GRECE &#8226; BULGARIE &#8226; ALBANIE &#8226; LITUANIE &#8226; ARMENIE &#8226; IRAN &#8226; SYRIE &#8226; BANGLADESH &#8226; EGYPTE &#8226; SENEGAL &#8226; GHANA &#8226; ZIMBABWE &#8226; CHINE &#8226; MEXIQUE</span>'
                ];

                //this.onBtnClick(txt);
                this.onLoad(txt);
            },

            animationOne: function (txt) {
                $('.index__map h1').html(txt);
                !$('.index__map h1').hasClass('active') && $('.index__map h1').addClass('active');
                $('.index__map .stars').attr('class', 'stars');
                $('.animation-indicators .dot.active').removeClass('active');
                $('.animation-indicators .dot:nth-of-type(1)').addClass('active');
            },

            animationTwo: function () {
                $('.index__map h1').removeClass('active');
                $('.index__map .stars').addClass('active');
                setTimeout(function () {
                    $('.animation-indicators .dot.active').removeClass('active');
                    $('.animation-indicators .dot:nth-of-type(2)').addClass('active');
                }, 600);
            },

            animationThree: function (txt) {
                $('.index__map .stars').addClass('faded');
                $('.index__map h1').addClass('active').html(txt);
                setTimeout(function () {
                    $('.animation-indicators .dot.active').removeClass('active');
                    $('.animation-indicators .dot:nth-of-type(3)').addClass('active');
                }, 300);
            },

            //onBtnClick: function (txt) {
            //    $('.index').on('click', '.dot', function () {
            //        var idx = $('.dot').index($(this));

            //        idx == 0 && lyap.Pages.Home.animationOne(txt[0]);
            //        idx == 1 && lyap.Pages.Home.animationTwo();
            //        idx == 2 && lyap.Pages.Home.animationThree(txt[1]);
            //    });
            //},

            onLoad: function (txt) {
                if ($('.page.index').length > 0) {
                    var activeLink = $('.header__lang a.active'),
                        lang = activeLink.attr('data-language') ? activeLink.attr('data-language').split('-')[0].toUpperCase() : activeLink.text().toUpperCase(),
                        slideText = lang === 'EN' ? txt[0] : txt[1];

                    setTimeout(function () { lyap.Pages.Home.animationTwo() }, 5000);
                    setTimeout(function () { lyap.Pages.Home.animationThree(slideText) }, 7000);
                }
            }
        }
    },

    Ajax: function () {
        $('#contact_form').on('submit', function (e) {
            e.preventDefault();
            var url = "/Page/SubmitContact";
            var data = $(this).serialize();

            $.ajax({
                type: "POST",
                url: url,
                dataType: "json",
                data: data,
                success: function (data) {
                    console.log('contact success');
                    console.log(data);
                    var messageAlert = 'alert-' + data.Type + ' text-success';
                    var messageText = data.Message;

                    var alertBox = '<div class="alert ' + messageAlert + ' alert-dismissable">' + messageText + '</div>';
                    if (messageAlert && messageText) {
                        $('#contact_form').find('.messages').html(alertBox);
                        $('#contact_form')[0].reset();
                        $('#contact_form').find('.hide-on-success').hide();
                    }
                },
                error: function (data) {
                    console.log('contact error');
                    console.log(data);
                    var result = data.responseJSON;
                    var messageAlert = 'alert-' + result.Type + ' text-danger';
                    var messageText = result.Message;

                    var alertBox = '<div class="alert ' + messageAlert + ' alert-dismissable">' + messageText + '</div>';
                    if (messageAlert && messageText) {
                        $('#contact_form').find('.messages').html(alertBox);
                        $('#contact_form')[0].reset();
                    }
                },
                complete: function (data) {
                    $('#contact_form').find('.close').on('click', function () {
                        $('#contact_form').find('.hide-on-success').show();
                    });
                }
            });
        });
    }
};

module.export = lyap;
window.lyap = lyap;